import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ReactNode } from "react";

const SectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h2,
  color: theme.palette.common.black,
  [theme.breakpoints.down("sm")]: {
    fontSize: "36px",
  },
}));

const HighlightText = styled("span")({
  background: "var(--blue-accent)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
});

interface SectionHeadingProps {
  highlightText?: string;
  children: ReactNode;
  maxWidth?: string;
  hasResponsiveBreak?: boolean;
}

export default function SectionHeading({
  highlightText,
  children,
  maxWidth,
}: SectionHeadingProps) {
  return (
    <Box sx={{ maxWidth }}>
      <SectionTitle>
        {highlightText && <HighlightText>{highlightText}</HighlightText>}
        {highlightText && " "}
        {children}
      </SectionTitle>
    </Box>
  );
}

export { SectionHeading };
